export default function CalcPercentage(mrp, sellingPrice) {
  const percentage = Math.round(((mrp - sellingPrice) / mrp) * 100)
  return percentage
}
